export default __webpack_public_path__ + "assets/images/909429db8a8bd741445fdf4cb2205612.svg";